<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <!--Arrange Columns List-->
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            <!--Reset Columns-->
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>
                                </div>
                            </CCardBody>

                            <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-if="header == 'AgentGroupName'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['AGT']}}
                                    </template>
                                    <template v-if="header == 'ProviderName'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GAME']['PROV']}}
                                    </template>
                                    <template v-if="header == 'UserID'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['U']}}
                                    </template>
                                    <template v-if="header == 'CampaignType'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PM']['CampaignType']}}
                                    </template>
                                    <template v-if="header == 'ISOC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['CI']}}
                                    </template>
                                    <template v-if="header == 'Amount'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PEPRPT']['A']}}
                                    </template>
                                    <template v-if="header == 'TransactionID'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PEPRPT']['TI']}}
                                    </template>
                                    <template v-if="header == 'PayoutTime'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PEPRPT']['PT']}}
                                    </template>
                                </li>
                            </draggable>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{checkModuleIndex('PEP', 'R', constAccessType.view, '', -1)}} {{this.getLanguage['SMB']['PEP']}}</h2>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>

                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="!hideBrand">
                                <span class='searchLabel'>{{this.getLanguage["GL"]["AGT"]}} :</span>
                                <customtreeselect :multiple="true"
                                                  :flat="true"
                                                  :limit="1"
                                                  :load-options="loadAgentOptions"
                                                  valueConsistsOf="LEAF_PRIORITY"
                                                  :options="ddAgentList"
                                                  :defaultExpandLevel="Infinity"
                                                  :auto-load-root-options="convertToBool(searchAgent)"
                                                  :disable-branch-nodes="false"
                                                  @input="selectAgentOptions"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  :limitText="count => `+${count}`"
                                                  v-model="searchAgent" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["BETRPT"]["GP"]}} :</span>
                                <treeselect :multiple="true"
                                            :load-options="loadGameProviderOptions"
                                            :defaultExpandLevel="1"
                                            valueConsistsOf="LEAF_PRIORITY"
                                            :options="ddGameProviderList"
                                            :auto-load-root-options="true"
                                            @input="selectGameProvider"
                                            :placeholder="this.utilGetDDLanguage('BETRPT.GP')"
                                            v-model="searchGameProviderId"
                                            :limit="1"
                                            :limitText="count => `+${count}`"
                                            class="gp-dropdown" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.startDate != ''">
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.endDate != ''">
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["U"]}} :</span>
                                <treeselect :key="dd_memberKey"
                                            :multiple="false"
                                            :async="true"
                                            :load-options="loadMemberOptions"
                                            :options="ddMemberList"
                                            :defaultOptions="ddDefaultMemberList"
                                            :auto-load-root-options="convertToBool(searchUserId > 0 && searchUsername)"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.U')"
                                            @input="selectMemberOptions"
                                            @deselect="deSelectMemberOptions"
                                            :cacheOptions="false"
                                            v-model="searchUserId" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CI"]}} :</span>
                                <treeselect :multiple="false"
                                            :load-options="loadSearchMemberCurrencyOptions"
                                            :options="ddCurrencyListFilter"
                                            :auto-load-root-options="false"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="searchCurrencyFilter" />
                            </div>
                        </div>

                        <div class='searchBtnCol'>
                            <CButton ref="search" v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' size="sm" block color="success" @click=" newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-summarywrapper'>
                <div class="custom-table-wrapper">
                    <table class='custom-table custom-tableMP afb-blue'>
                        <thead v-if="bool_showSummary">
                            <tr>
                                <th class="tableCtnRight">{{this.getLanguage['MEM']['CI']}}</th>
                                <th class="tableCtnRight">{{this.getLanguage['PEPRPT']['TC']}}</th>
                                <th class="tableCtnRight">{{this.getLanguage['PEPRPT']['TA']}}</th>
                            </tr>
                        </thead>
                        
                        <tbody v-if="bool_showSummary">
                            <tr><td colspan="100%" v-if="arr_reportTotalList.length == 0">{{this.getLanguage['GL']['NR']}}</td></tr>
                            <tr v-for="(data,index) in arr_reportTotalList">
                                <td class="tableCtnRight">{{ data.ISOC }}</td>
                                <td class="tableCtnRight">{{ formatNumber(data.TotalCount, 0) }}</td>
                                <td class="tableCtnRight text-green">{{ formatNumber(data.TotalAmount, 2, data.ISOC, false) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class='table-wrapper'>
                <header class="table-header">
                    <!--Provider Event Payout List-->
                    <strong>{{getLanguage['PETRPT']['PETL']}}</strong>
                    <div class="pageBtn">
                        <!--Arr. Columns-->
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            <!--Reset Columns-->
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                            <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                            <!--Download-->
                            {{this.getLanguage["BTN"]["DL"]}}
                        </CButton>

                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>
      
                <div class="custom-table-wrapper">
                    <table class='custom-table afb-blue'>
                        <!--標頭-->
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)" :style="renderBackgroundColor(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'AgentGroupName' && !hideBrand">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['AGT']}}
                                        <i @click="setSortTable('AgentGroupName')" :class="setSortLogo('AgentGroupName')"></i>
                                    </template>
                                    <template v-else-if="header == 'ProviderName'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GAME']['PROV']}}
                                        <i @click="setSortTable('ProviderName')" :class="setSortLogo('ProviderName')"></i>
                                    </template>
                                    <template v-else-if="header == 'UserID'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['U']}}
                                        <i @click="setSortTable('UserID')" :class="setSortLogo('UserID')"></i>
                                    </template>
                                    <template v-else-if="header == 'CampaignType'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PM']['CampaignType']}}
                                        <i></i>
                                    </template>
                                    <template v-else-if="header == 'ISOC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['CI']}}
                                        <i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')"></i>
                                    </template>
                                    <template v-else-if="header == 'Amount'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PEPRPT']['A']}}
                                        <i @click="setSortTable('Amount')" :class="setSortLogo('Amount')"></i>
                                    </template>
                                    <template v-else-if="header == 'TransactionID'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PEPRPT']['TI']}}
                                        <i @click="setSortTable('TransactionID')" :class="setSortLogo('TransactionID')"></i>
                                    </template>
                                    <template v-else-if="header == 'PayoutTime'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <font>
                                            {{getLanguage['PEPRPT']['PT']}}<i @click="setSortTable('PayoutTime')" :class="setSortLogo('PayoutTime')"></i>
                                        </font>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                            <!--No Record-->
                            <tr><td colspan="100%" v-if="arr_reportList.length == 0">{{this.getLanguage['GL']['NR']}}</td></tr>
                            <tr v-for="(data,index) in arr_reportList">
                                <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header, data)">
                                    <template v-if="header == 'NO'">
                                        {{ data.row }}
                                    </template> <!-- row count -->
                                    <template v-else-if="header == 'AgentGroupName' && !hideBrand">
                                        {{ data.AgentGroupName }}
                                    </template><!-- brand -->
                                    <template v-else-if="header == 'ProviderName'">
                                        {{ data.ProviderName }}
                                    </template><!-- ProviderName -->
                                    <template v-else-if="header == 'UserID'">
                                        {{ data.UserID }}
                                    </template><!-- UserID -->
                                    <template v-else-if="header == 'CampaignType'">
                                        {{ data.CampaignType }}
                                    </template><!-- Campaign Type -->
                                    <template v-else-if="header == 'ISOC'">
                                        {{ data.ISOC }}
                                    </template><!-- currency -->
                                    <template v-else-if="header == 'Amount'">
                                        {{ formatNumber(data.Amount, 2, data.ISOC, false) }}
                                    </template><!-- Amount -->
                                    <template v-else-if="header == 'TransactionID'">
                                        {{ data.TransactionID }}
                                    </template><!-- TransactionID -->
                                    <template v-else-if="header == 'PayoutTime'">
                                        {{ formatDateTime(data.PayoutTime, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}
                                    </template><!-- PayoutTime -->
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import Loading from 'vue-loading-overlay';
    import moment from "moment";
    import 'vue-loading-overlay/dist/vue-loading.css';
    import genericHelper from "@/modules/GenericHelper.js";
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { mapGetters, mapActions } from 'vuex';
    import Vue from 'vue'
    import { constAccessType, constRejectReasonD, loadingFullScreen } from '@/modules/Constant.js';
    import draggable from 'vuedraggable';
    import $ from 'jquery'

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            draggable
        },
        data() {
            return {
                int_RC: 100, //Row Count
                int_Page: 1, //current Page
                int_TP : 1,
                repoertIsCrypto: false,
                reportHeaders: [],
                // dropdown value
                ddAgentList: null,
                ddAgentList2: null,
                ddGameProviderList: null,
                ddMemberList: null,
                ddDefaultMemberList: null,
                ddReferralMemberList: null,
                ddReferralDefaultMemberList: null,
                ddCurrencyListFilter: null,
                dd_memberKey: 0,
                // search fields
                searchAgi2: '',
                searchAgent: null,
                searchAgT: 0,
                searchUsername: null,
                searchCurrencyFilter: null,                
                arr_reportList: [],
                arr_reportTotalList: [],
                str_tableSortBy: "TA", //(sort the table col name)                
                hideBrand: false,
                bool_showSearchBar: true,
                bool_isSort: true, // Table Ascending Descending
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSummary: true,
                bool_isDDMV: false,
                searchCreatedTS: { startDate: this.getTodayDate(), endDate: this.getMonthEndDate() },
                searchGameProviderId: [],
                searchUserId: null,
                needResetHeaders: false,
                str_showDetails: "",
                constAccessType: constAccessType,
                defaultReportHeaders: ['NO', 'AgentGroupName', 'ProviderName', 'UserID', 'CampaignType', 'ISOC', 'Amount', 'TransactionID', 'PayoutTime'],
                obj_Post: {
                    SelectedBrands1: null
                },
            }
        },
        methods: {
            ...mapActions('UserInfo', ['setSearchCriteriaAGI']),             
            loadSearchMemberCurrencyOptions({ action, callback, instanceId }) {
                var that = this;
                if (!this.searchAgi2) {
                    this.searchAgi2 = 0;
                }

                //this.getDataApi(`/api/dd/currency/${this.searchAgi2}`,
                this.obj_Post.SelectedBrands1 = this.searchAgi2;

                this.postDataApi(`/api/dd/curbyagilist/1`, this.obj_Post,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddCurrencyListFilter = d.dropdownlist;
                        }
                        else {
                            that.ddCurrencyListFilter = null;
                        }

                        callback();
                    });
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getReportList();
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            renderClassName(header, data) {
                return "tableCtnRight";
            },
            renderBackgroundColor(header) {
               
            },
            resetColumn(headerName) {
                var that = this;
                if (that.hideBrand) {
                    that.removeDefaultColumn('AgentGroupName')
                }

                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            loadAgentOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddAgentList = d.dropdownlist;
                            that.ddAgentList2 = d.dropdownlist;
                        }
                        else {
                            that.ddAgentList = null;
                            that.ddAgentList2 = null;
                            that.searchAgT = 0;
                        }

                        callback();
                    });
            },
            loadGameProviderOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi('/api/dd/game/prov/0/1/1',
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            for (var j = 0; j < d.dropdownlist.length; j++) {
                                d.dropdownlist[j].label = that.renderCategory(d.dropdownlist[j].id.slice(d.dropdownlist[j].id.indexOf('-') + 1));
                                if (d.dropdownlist[j].children != null && d.dropdownlist[j].children.length > 0) {
                                    for (var l = 0; l < d.dropdownlist[j].children.length; l++) {
                                        if (d.dropdownlist[j].children[l].label in that.getLanguage['GP'])
                                            d.dropdownlist[j].children[l].label = that.renderProviderName(d.dropdownlist[j].children[l].label);
                                    }

                                }
                            }

                            that.ddGameProviderList = that.appendSelectAllOption(d.dropdownlist);
                        }
                        else {
                            that.ddGameProviderList = null;
                        }
                        callback();
                        //if (that.searchGameProviderId > 0) {
                        //    that.selectGameProvider(that.searchGameProviderId);
                        //}
                    });
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    // this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.searchAgi2}`,
                    this.obj_Post.SelectedBrands1 = this.searchAgi2;

                    this.postDataApi(`/api/dd/mreferralbypost/${searchQuery}`, this.obj_Post,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            selectAgentOptions(value, instanceId) {
                if (value && value.length > 0) {
                    var agentList = value[0].split("-");
                    this.searchAgT = agentList[agentList.length - 2];
                }

                var temp = "";
                for (var x = 0; x < value.length; x++) {
                    if (x != 0) {
                        temp += ",";
                    }
                    var split = value[x].split("-");

                    if (split.length == 2) {
                        temp += split[1];
                    }
                    else {
                        temp += split[0];
                    }
                }
                this.searchAgi = temp;
                this.ddCurrencyListFilter = null;
                this.searchCurrencyFilter = null;
                this.selectedAgent = value;
                this.searchAgent2Main = value;
                this.getAgentGroup();
            },
            selectGameProvider(value, instanceId) {

            },
            selectMemberOptions(node, instanceId) {
                if (this.ddMemberList && this.ddMemberList.length > 0) {
                    var index = -1;
                    for (var i = 0; i < this.ddMemberList.length; i++) {
                        if (this.ddMemberList[i].id == node) {
                            this.searchUsername = this.ddMemberList[i].label;
                            break;
                        }
                    }
                }
                else {
                    this.searchUsername = null;
                }
            },
            getAgentGroup(value) {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0/1`,
                    function (d, s) {
                        if (s) {
                            that.ddAgentList = that.deepClone(d.dropdownlist);
                            that.ddAgentList2 = that.deepClone(d.dropdownlist);

                            if (that.ddAgentList.length > 0) {
                                that.disableAgentGroupLevel();
                            }
                            if (that.ddAgentList2.length > 0) {
                                that.selectAgentGroup2Level();
                            }
                        }
                    });
            },
            disableAgentGroupLevel() {
                var that = this;
                if (that.selectedAgent != null && that.selectedAgent.length > 0) {
                    var selectedAgent = that.selectedAgent[0].split("-")[0];
                    for (var j = 0; j < that.ddAgentList.length; j++) {
                        var itemLevel = that.ddAgentList[j].id.split("-")[0];

                        if (selectedAgent != itemLevel && itemLevel == "0") {
                            that.ddAgentList[j].isDisabled = true;
                        }

                        if (that.ddAgentList[j].children && that.ddAgentList[j].children.length > 0) {
                            for (var k = 0; k < that.ddAgentList[j].children.length; k++) {
                                var itemLevel1 = that.ddAgentList[j].children[k].id.split("-")[0];

                                if (selectedAgent != itemLevel1 && itemLevel1 == "1") {
                                    that.ddAgentList[j].children[k].isDisabled = true;
                                }

                                if (that.ddAgentList[j].children[k].children && that.ddAgentList[j].children[k].children.length > 0) {
                                    for (var l = 0; l < that.ddAgentList[j].children[k].children.length; l++) {
                                        var itemLevel2 = that.ddAgentList[j].children[k].children[l].id.split("-")[0];

                                        if (selectedAgent != itemLevel2 && itemLevel2 == "2") {
                                            that.ddAgentList[j].children[k].children[l].isDisabled = true;
                                        }

                                        if (that.ddAgentList[j].children[k].children[l].children && that.ddAgentList[j].children[k].children[l].children.length > 0) {
                                            for (var m = 0; m < that.ddAgentList[j].children[k].children[l].children.length; m++) {
                                                var itemLevel3 = that.ddAgentList[j].children[k].children[l].children[m].id.split("-")[0];

                                                if (selectedAgent != itemLevel3 && itemLevel3 == "3") {
                                                    that.ddAgentList[j].children[k].children[l].children[m].isDisabled = true;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                } else {
                    that.searchAgent2Main = that.selectedAgent;
                    that.searchAgent2 = [];
                    that.searchAgT = 0;
                }
            },
            selectAgentGroup2Level() {
                var that = this;
                that.searchAgent2 = [];

                for (var h = 0; h < that.searchAgent2Main.length; h++) {
                    that.searchAgent2.push(that.searchAgent2Main[h]);
                    var currentAgent = that.searchAgent2Main[h];
                    var selectedAgentLevel = that.searchAgent2Main[h].split("-")[0];
                    for (var j = 0; j < that.ddAgentList2.length; j++) {
                        var itemLevel = that.ddAgentList2[j].id.split("-")[0];

                        if (parseFloat(selectedAgentLevel) < parseFloat(itemLevel)) {
                            this.searchAgent2.push(that.ddAgentList2[j].id);
                        }

                        if (that.ddAgentList2[j].children && that.ddAgentList2[j].children.length > 0) {
                            for (var k = 0; k < that.ddAgentList2[j].children.length; k++) {
                                var itemLevel1 = that.ddAgentList2[j].children[k].id.split("-")[0];

                                if (parseFloat(selectedAgentLevel) < parseFloat(itemLevel1)) {
                                    if (currentAgent == that.ddAgentList2[j].id) {
                                        this.searchAgent2.push(that.ddAgentList2[j].children[k].id);
                                    }
                                }

                                if (that.ddAgentList2[j].children[k].children && that.ddAgentList2[j].children[k].children.length > 0) {
                                    for (var l = 0; l < that.ddAgentList2[j].children[k].children.length; l++) {
                                        var itemLevel2 = that.ddAgentList2[j].children[k].children[l].id.split("-")[0];

                                        if (parseFloat(selectedAgentLevel) < parseFloat(itemLevel2)) {
                                            if (currentAgent == that.ddAgentList2[j].id ||
                                                currentAgent == that.ddAgentList2[j].children[k].id) {
                                                this.searchAgent2.push(that.ddAgentList2[j].children[k].children[l].id);
                                            }
                                        }

                                        if (that.ddAgentList2[j].children[k].children[l].children && that.ddAgentList2[j].children[k].children[l].children.length > 0) {
                                            for (var m = 0; m < that.ddAgentList2[j].children[k].children[l].children.length; m++) {
                                                var itemLevel3 = that.ddAgentList2[j].children[k].children[l].children[m].id.split("-")[0];

                                                if (parseFloat(selectedAgentLevel) < parseFloat(itemLevel3)) {
                                                    if (currentAgent == that.ddAgentList2[j].id ||
                                                        currentAgent == that.ddAgentList2[j].children[k].id ||
                                                        currentAgent == that.ddAgentList2[j].children[k].children[l].id) {
                                                        this.searchAgent2.push(that.ddAgentList2[j].children[k].children[l].children[m].id);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                var temp2 = "";
                for (var x = 0; x < this.searchAgent2.length; x++) {
                    if (x != 0) {
                        temp2 += ",";
                    }
                    var split = this.searchAgent2[x].split("-");

                    if (split.length == 2) {
                        temp2 += split[1];
                    }
                    else {
                        temp2 += split[0];
                    }
                }
                this.searchAgi2 = temp2;
            },
            deSelectMemberOptions(node, instanceId) {
                this.searchUserId = null;
                this.searchUsername = null;
            },
            renderCategory(id) {
                return this.getLanguage["GC"][id];
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.bool_isSortSearch = false;
                if (this.searchCreatedTS) {
                    if (this.searchCreatedTS.startDate != "") {
                        var z = this.set90daysDateSearch(this.searchCreatedTS.startDate);
                        if (z == true) {
                            return;
                        }
                    }
                }
                this.getReportList();
            },
            clearDateRangeFilter() {
                this.searchCreatedTS.startDate = this.getTodayDate();
                this.searchCreatedTS.endDate = this.getMonthEndDate();
            },
            getMemberTypeList() {
                this.dd_userType = [{ id: '1', label: this.getLanguage['MEM']['NMEM'] }, { id: '2', label: this.getLanguage['MEM']['TMEM'] }];
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('EPE', 'R', type);
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getReportList();
            },
            getReportList() {                
                this.bool_fullLoading = true;
                var that = this;

                var param = {
                    "p": this.int_Page,
                    "n": this.int_RC,
                    "s": that.str_tableSortBy,
                    "d": that.bool_isSort,
                    "f": {
                        "AGI_csv": (this.searchAgi2 != 0) ? this.searchAgi2 : "",                        
                        "CIF": this.searchCurrencyFilter,
                        "AGT": (this.searchAgT != null) ? this.searchAgT : 0,
                        "GPI_csv": (_.toString(this.searchGameProviderId) == "") ? null : _.toString(this.searchGameProviderId),
                        "STS_from": (this.searchCreatedTS.startDate != '') ? this.parseDateToJsonString(this.searchCreatedTS.startDate) : "",
                        "STS_to": (this.searchCreatedTS.endDate != '') ? this.parseDateToJsonString(this.searchCreatedTS.endDate) : "",
                        "MI": this.searchUserId
                    }
                }
                sessionStorage.setItem('PEP_FilterAGI', '');
                sessionStorage.setItem('PEP_FilterCIF', '');
                sessionStorage.setItem('PEP_FilterAgent', '');
                sessionStorage.setItem('PEP_FilterMI', '');
                sessionStorage.setItem('PEP_FilterGPI', '');
                sessionStorage.setItem('PEP_FilterSTS_from', '');
                sessionStorage.setItem('PEP_FilterSTS_to', '');

                if (this.searchAgi2) {
                    sessionStorage.setItem('PEP_FilterAGI', this.searchAgi2);
                    sessionStorage.setItem('PEP_FilterAgent', this.searchAgent);
                }
                if (this.searchAgT != null) {
                    this.pre_searchAgT = this.searchAgT;
                }
                if (this.searchUserId) {
                    sessionStorage.setItem('PEP_FilterMI', this.searchUserId);
                    sessionStorage.setItem('PEP_FilterMName', this.searchUsername);
                }
                if (this.searchGameProviderId) {
                    sessionStorage.setItem('PEP_FilterGPI', this.searchGameProviderId);
                }
                if (this.searchCurrencyFilter) {
                    sessionStorage.setItem('PEP_FilterCIF', this.searchCurrencyFilter);
                }
                if (this.searchCreatedTS) {

                    if (this.searchCreatedTS.startDate != "") {
                        sessionStorage.setItem('PEP_FilterSTS_from', this.parseDateToJsonString(this.searchCreatedTS.startDate));
                    }

                    if (this.searchCreatedTS.endDate != "") {
                        sessionStorage.setItem('PEP_FilterSTS_to', this.parseDateToJsonString(this.searchCreatedTS.endDate));
                    }
                }                

                this.postDataApi(`/api/reports/ProviderEventPayoutList`, param,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.repoertIsCrypto = false;
                            that.sc_userid = that.searchUserId;
                            that.sc_username = that.searchUsername;
                            that.sc_daterange = that.searchCreatedTS;
                            if (d.R1) {
                                var count = 0;
                                for (var i = 0; i < d.R1.length; i++) {
                                    if (d.R1[i].ProviderName in that.getLanguage['GP'])
                                        d.R1[i].ProviderName = that.getLanguage['GP'][d.R1[i].ProviderName];

                                    switch (d.R1[i].GameProviderId) {
                                        case 20: case 35: case 94:
                                            switch (d.R1[i].CampaignType) {
                                                case "T":
                                                    d.R1[i].CampaignType = that.getLanguage['PM']['TOUR'];
                                                    if (that.getLanguage['PM']['TOUR'] == undefined)
                                                        d.R1[i].CampaignType = "Tournament";
                                                    break;
                                                case "CJP":
                                                    d.R1[i].CampaignType = that.getLanguage['PM']['CJP'];
                                                    if (that.getLanguage['PM']['CJP'] == undefined)
                                                        d.R1[i].CampaignType = "Community Jackpot";
                                                    break;
                                                case "CB":
                                                    d.R1[i].CampaignType = that.getLanguage['PM']['CashBack'];
                                                    if (that.getLanguage['PM']['CashBack'] == undefined)
                                                        d.R1[i].CampaignType = "Cash Back";
                                                    break;
                                                case "R":
                                                    d.R1[i].CampaignType = that.getLanguage['PM']['PrizeDrop'];
                                                    if (that.getLanguage['PM']['PrizeDrop'] == undefined)
                                                        d.R1[i].CampaignType = "Prize Drop";
                                            }
                                            break;
                                    }

                                    count = count + 1;
                                    d.R1[i].row = count;
                                }
                            }

                            if (d.R2.length != 0)
                                that.int_TP = Math.max(d.R2[0].TotalPages, 1);

                            that.arr_reportList = d.R1;
                            that.arr_reportTotalList = d.R2;
                            that.resizeTableHead();
                        }
                    });
            },
            saveToExcel() {
                var that = this;
                var param = {
                    "p": this.int_Page,
                    "n": this.int_RC,
                    "s": that.str_tableSortBy,
                    "d": that.bool_isSort,
                    "f": {
                        "AGI_csv": (this.searchAgi2 != 0) ? this.searchAgi2 : "",
                        "CIF": this.searchCurrencyFilter,
                        "AGT": (this.searchAgT != null) ? this.searchAgT : 0,
                        "GPI_csv": (_.toString(this.searchGameProviderId) == "") ? null : _.toString(this.searchGameProviderId),
                        "STS_from": (this.searchCreatedTS.startDate != '') ? this.parseDateToJsonString(this.searchCreatedTS.startDate) : "",
                        "STS_to": (this.searchCreatedTS.endDate != '') ? this.parseDateToJsonString(this.searchCreatedTS.endDate) : "",
                        "MI": this.searchUserId
                    }
                }
                var form = document.createElement("form");
                form.method = "POST";
                form.action = "/api/reports/eventexcel/ProviderEventPayoutList";
                form.target = "_blank";

                for (var key in param) {
                    if (param.hasOwnProperty(key) && key == "f") {
                        for (var fkey in param['f']) {
                            var hiddenField = document.createElement('input');
                            hiddenField.type = "hidden";
                            hiddenField.name = key + '[' + fkey + ']'
                            hiddenField.value = param['f'][fkey];
                            form.appendChild(hiddenField);
                        }
                    }
                    else if (param.hasOwnProperty(key)) {
                        var hiddenField = document.createElement('input');
                        hiddenField.type = "hidden";
                        hiddenField.name = key;
                        hiddenField.value = param[key];
                        form.appendChild(hiddenField);
                    }
                }

                document.body.appendChild(form);
                form.submit();     
            },
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserMemberSC', 'getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),
        },
        created() {
            this.reportHeaders = null;
            this.$parent.showSubMenu = 'R';
            this.$parent.showActiveMenu = 'R.PEP';
            if (this.checkModuleIndex('PEP', 'R', constAccessType.view, '', -1) == '7.3.11') {
                this.$parent.showSubSubMenu = 'RS3';
            } else if (this.checkModuleIndex('PEP', 'R', constAccessType.view, '', -1) == '8.4.9') {
                this.$parent.showSubSubMenu = 'RS4';
            }

            this.hideBrand = this.getUserInfo.IHAGIF;
            this.hide = this.getUserInfo.SBSA;
            if (this.$route.query.back && this.$route.query.back == 1) {
                var FilterAGI = sessionStorage.getItem('PEP_FilterAGI');
                var FilterAgent = sessionStorage.getItem('PEP_FilterAgent');
                if (FilterAGI && FilterAgent) {
                    this.searchAgi = FilterAGI;
                    this.searchAgent = FilterAgent.split(',');
                }
                var FilterSAGI = sessionStorage.getItem('PEP_FilterSAGI');
                if (FilterSAGI) {
                    this.searchSubAgent = FilterSAGI;
                }

                var FilterGPI = sessionStorage.getItem('PEP_FilterGPI');
                if (FilterGPI) {
                    this.searchGameProviderId = FilterGPI.split(',');
                }

                var FilterMI = sessionStorage.getItem('PEP_FilterMI');
                var FilterMName = sessionStorage.getItem('PEP_FilterMName');
                if (FilterMI && FilterMName) {
                    this.searchUserId = FilterMI;
                    this.searchUsername = FilterMName;
                    this.ddDefaultMemberList = [
                        { id: this.searchUserId, label: this.searchUsername }
                    ];
                }

                var FilterRI = sessionStorage.getItem('PEP_FilterRI');
                var FilterRName = sessionStorage.getItem('PEP_FilterRName');
                if (FilterRI && FilterRName) {
                    this.searchReferralUserId = FilterRI;
                    this.searchReferralUsername = FilterRName;
                    this.ddReferralDefaultMemberList = [
                        { id: this.searchReferralUserId, label: this.searchReferralUsername }
                    ];
                }

                var FilterITU = sessionStorage.getItem('PEP_FilterITU');
                if (FilterITU) {
                    this.searchIsTester = FilterITU;
                }

                var FilterSTS_from = sessionStorage.getItem('PEP_FilterSTS_from');
                if (FilterSTS_from) {
                    this.searchCreatedTS.startDate = FilterSTS_from;
                }

                var FilterSTS_to = sessionStorage.getItem('PEP_FilterSTS_to');
                if (FilterSTS_to) {
                    this.searchCreatedTS.endDate = FilterSTS_to;
                }
            }
            else {
                if (this.$route.query.sagi && this.$route.query.sagi != 0) {
                    this.searchAgent = [];
                    this.searchAgent.push(this.$route.query.sagi);

                    var agentList = this.$route.query.sagi.split("-");
                    this.searchAgT = agentList[agentList.length - 2];

                    if (this.$route.query.agi && this.$route.query.agi != 0) {
                        this.searchAgi2 = this.$route.query.agi;
                    }
                }

                if (this.$route.query.gpi) {
                    this.searchGameProviderId = ($.isArray(this.$route.query.gpi) ? this.$route.query.gpi : [this.$route.query.gpi]);
                }

                if (this.$route.query.ut) {
                    this.searchIsTester = this.$route.query.ut;
                }

                if (this.$route.query.curf) {
                    this.searchCurrencyFilter = this.$route.query.curf;
                }

                if (this.$route.query.df) {
                    this.searchCreatedTS.startDate = this.$route.query.df;
                }

                if (this.$route.query.dt) {
                    this.searchCreatedTS.endDate = this.$route.query.dt;
                }

                if (this.$route.query.i && this.$route.query.u) {
                    this.searchUserId = this.$route.query.i;
                    this.searchUsername = this.$route.query.u;
                    this.ddDefaultMemberList = [
                        { id: this.searchUserId, label: this.searchUsername }
                    ];
                }

                if (this.$route.query.iref && this.$route.query.uref) {
                    this.searchReferralUserId = this.$route.query.iref;
                    this.searchReferralUsername = this.$route.query.uref;
                    this.ddReferralMemberList = [
                        { id: this.searchReferralUserId, label: this.searchReferralUsername }
                    ];
                }
            }
            this.getMemberTypeList();
            if (this.$route.path != this.$route.fullPath) {
                this.getReportList();
            } else {
                sessionStorage.setItem(this.$route.path, '');
            }
        },
        watch: {
            getLanguage() {
                this.getMemberTypeList();
            },
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/ProviderEventPayout`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                                }

                                if (that.hideBrand) {
                                    that.removeDefaultColumn('AgentGroupName')
                                    that.removeColumn('AgentGroupName')
                                }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/ProviderEventPayout/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            }
        },
    }
</script>




// WEBPACK FOOTER //
// src/components/SideMenu/Reports/ProviderEventPayout.vue